<!-- Index-1 component -->
<script>
  import { Modal, ModalBody, ModalHeader } from "sveltestrap";
  import Navbar from "../Components/Navbar.svelte";

  import Services from "../Components/Services.svelte";
  import Certifications from "../Components/Certifications.svelte";
  import Ourway from "../Components/Ourway.svelte";
  import Pricing from "../Components/Pricing.svelte";
  import Team from "../Components/Team.svelte";
  import HomeHighlights from "../Components/HomeHighlights.svelte";
  import Testimonial from "../Components/Testimonial.svelte";
  import Contact from "../Components/Contact.svelte";
  
  import Footer from "../Components/Footer.svelte";

  import data from "../Data/data";

</script>

<!-- STRAT NAVBAR -->
<Navbar />
<!-- END NAVBAR -->

<section
  class="section section-lg home-half common-section"
  id="home"
  style="background-image: url('images/MariHouseDrawingWithFrame.jpg'); background-size: cover; background-position: top;">
  <div class="bg-overlay" />
  <div class="display-table">
    <div class="home-cell-bottom">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-white text-center">
            <h1 class="home-title">Home Inspections - done right</h1>
            <p class="pt-5 home-desc">
              Don't take a chance when buying your home.  Protect your investment with a thorough, detailed inspection.
            </p>
            <!-- <div class="mt-4"> -->
              <!-- <video width="50%" height="auto" controls class="frame-border">
                <source src="theladiesjump.mp4" type="video/mp4">
              </video>               -->
            <!-- </div>  -->
<!--START PROCESS-->
<!--END PROCESS-->
            <HomeHighlights teamData={data.TEAM_DATA} />
          <div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
 
<!--END HOME-->
<!--END HOME-->


<Services serviceData={data.SERVICE_DATA} />
<Certifications certificationData={data.CERTIFICATION_DATA} />
<Ourway ourwayData={data.OURWAY_DATA} />
<Pricing pricingData={data.PRICING_DATA} />
<Team teamData={data.TEAM_DATA} />
<Testimonial testimonialData={data.TESTIMONIAL_DATA} />
<Contact />
<Footer />
